import { render, staticRenderFns } from "./HistoricalUserFilter.vue?vue&type=template&id=305fbfec&scoped=true&"
import script from "./HistoricalUserFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalUserFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305fbfec",
  null
  
)

export default component.exports